import { Divider, Form, Input } from "antd";
import React, { FC } from "react";

const { TextArea } = Input;

interface CommentFormProps {
  name: string;
  title?: string;
  disabled: boolean;
}

export const CommentForm: FC<CommentFormProps> = (props) => {
  const { name, title, disabled } = props;

  return (
    <>
      <Divider orientation="left" orientationMargin="0">
        {title ? title : "Дополнительный комментарий"}
      </Divider>
      <Form.Item name={name}>
        <TextArea
          showCount
          maxLength={5000}
          placeholder="Введите комментарий"
          style={{ height: 157 }}
          disabled={disabled}
        />
      </Form.Item>
    </>
  );
};
